import { render, staticRenderFns } from "./Arrangement.vue?vue&type=template&id=87526f06&"
import script from "./Arrangement.vue?vue&type=script&lang=js&"
export * from "./Arrangement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports